import { Controller } from "@hotwired/stimulus";
import { Plugins, Sortable } from "@shopify/draggable";
import { put } from '@rails/request.js'

export default class extends Controller {
  static values = {
    refreshFrame: String,
    refreshUrl: String,
    updateUrl: String,
  }

  connect() {
    this.sortable = this.setupSortable()
  }

  checkForReinitialization(mutatedRecords){
    mutatedRecords.forEach((mutatedRecord) => {
      const { addedNodes } = mutatedRecord

      addedNodes.forEach((addedNode) => {
        const { dataset } = addedNode
        
        if (dataset?.sortableListReinit === 'true'){
          this.reinitializeSortable()
        }
      })
    })
  }

  reinitializeSortable(){
    if (this.sortable){
      this.sortable.destroy()
      this.sortable = this.setupSortable()
    }
  }

  setupSortable(){
    const multipleContainers = document.querySelectorAll('.sortable-list-container')
    const sortableContainers = multipleContainers.length ? multipleContainers : this.element

    const plugins = []
    if (!multipleContainers.length) plugins.push(Plugins.SortAnimation)

    const sortable = new Sortable(sortableContainers, {
      draggable: '.sortable-item',
      distance: 1,
      classes: {
        "mirror": ['z-20'],
      },
      handle: '.sortable-item-handle',
      mirror: {
        appendTo: 'body',
        constrainDimensions: true,
      },
      plugins,
      swapAnimation: {
        duration: 200,
        easingFunction: 'ease-in-out',
      },
    });

    this.observer = new MutationObserver(this.checkForReinitialization.bind(this));
    this.observer.observe(this.element, {
      childList: true,
      attributes: false,
      subtree: true
    });

    // sortable.on('sortable:start', (e) => console.log('sortable:start', e));
    sortable.on('sortable:sort', this.dragOverContainer.bind(this, sortable))

    // sortable.on('drag:over:container', this.dragOverContainer.bind(this, sortable))
    sortable.on('drag:out:container', this.dragOutContainer.bind(this, sortable))
    
    sortable.on('sortable:stop', this.sortComplete.bind(this, sortable));

    // sortable.on('sortable:sorted', () => console.log('sortable:sorted'));

    return sortable
  }

  dragOverContainer(sortable, e){
    const {
      dragEvent: {
        data: {
          originalSource,
          overContainer,
        },
      },
    } = e

    // No restriction set, carry on
    if (!overContainer?.dataset?.sortableAcceptedItemTypes){
      return
    }

    const acceptedItemTypes = overContainer.dataset.sortableAcceptedItemTypes.split(',')
    const sortableType = originalSource?.dataset?.sortableType

    if (!acceptedItemTypes.includes(sortableType)){
      sortable.mirror.dataset.isDragValid = false
      e.cancel()
      return
    }
  }

  dragOutContainer(sortable, e){
    if (sortable?.mirror){
      sortable.mirror.dataset.isDragValid = true
    }
  }

  async sortComplete(sortable) {
    const sortedItems = sortable.getDraggableElementsForContainer(this.element).map((item, index) => {
      const itemContainer = item.closest('.sortable-list-container')

      return {
        id: item?.dataset?.sortableId,
        containerId: itemContainer?.dataset?.sortableContainerId,
        type: item?.dataset?.sortableType,
      }
    })

    const sortedIds = sortedItems.map(item => item.id)

    if (this.updateUrlValue){
      const response = await put(this.updateUrlValue, {
        body: JSON.stringify({
          sorted_ids: sortedIds,
          sorted_items: sortedItems,
        }),
        responseKind: this.updateUrlValue.includes('.json') ? 'json' : 'turbo-stream',
      })

      if (this.hasRefreshUrlValue){
        const data = await response.json
        if (data?.should_refresh){
          Turbo.visit(this.refreshUrlValue, { frame: this.refreshFrameValue, action: "replace" })
        }
      }
    }
  }
}
